<template>
    <div class="pages-create">
        <Form :model="pages" ref="activityAdd" label-position="right" :rules="actValidate" :label-width="80" action="javascript:void(0)" >
           <FormItem label="标题" prop="title">
                <Input v-model="pages.title" placeholder="输入标题..." style="width: 500px" ></Input>
            </FormItem>
            <FormItem label="详细" >
                <Input v-model="pages.desc" placeholder="输入描述..." type="textarea"  style="width: 500px"></Input>
            </FormItem>
            <FormItem label="顶图">
                <upload-thumb v-model="pages.img_url" ref="uploadthumb" :defaultList="thumblist" tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,建议图片宽度为750,大小不超过2M</span>"></upload-thumb>
            </FormItem>
             <FormItem label="视频">
                <upload-video v-model="pages.video" ref="uploadVideo" :defaultList="videolist"></upload-video>
            </FormItem>

<!--            <FormItem label="规则说明">-->
<!--                <editor-bar v-model="editor.info" :isClear="isClear"  ref="editContent" @change="change"></editor-bar>-->
<!--            </FormItem>-->
            <FormItem label="规则说明">
                <UEditor v-model="pages.info" ref="editContent"></UEditor>
            </FormItem>

            <FormItem>
                <!-- <Button>重置</Button> -->
                <Button type="primary" @click="submitAdd('activityAdd')" style="margin-left: 8px">提交</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
    // import EditorBar from "../common/editor"
    import UploadThumb from '../common/thumb'
    import UploadVideo from '../common/video'
    import UEditor from '../common/ueditor'
    export default {
        name: "pages-create",
        data () {
            return {
                cateSelect:[
                ],
                pages:{
                    title:'',
                    desc:'',
                    info:''
                },
                // 编辑器用的
                editor: {
                    info: ''
                },
                isClear: false,
                actValidate: {
                    title: [
                        { required: true, message: '标题必须填写', trigger: 'blur',type:'string'}
                    ]
                },
                uploadList: [],
                formItem:{
                    pages_activity_begin_time:'',
                    pages_activity_end_time:'',
                },
                thumblist:[],
                videolist:[],
                id:'',
            }
        },
        // 组件
        components: {
            // EditorBar,
            UploadThumb,
            UploadVideo,
            UEditor
        },
        created: function () {
            // 取数据
            this.id = this.$route.query.id;
            if(this.id ==0){
                var that = this;
                setTimeout(function(){
                    that.$refs['activityAdd'].resetFields();
                },1);
            }else{
                this.$api.pages.detail({id:this.id}).then(res=>{
                    if(res.code == 200) {
                        this.pages = res.result;
                        // this.pages.cascData = [this.pages.province_id,this.pages.city_id,this.pages.area_id];
                        if(this.pages.img_url!=null && this.pages.img_url != ''){
                            this.thumblist.push({
                                 name:this.pages.img_url,
                                 url:this.pages.img_url,
                                 status:'finished'
                             });
                        }
                        if(this.pages.video!=null && this.pages.video != ''){
                            this.videolist.push({
                                 name:this.pages.video,
                                 url:this.pages.video,
                                 status:'finished'
                             });
                        }
                        let tval = this.pages.text;
                        // var newtval = tval.replace(/\<img src\=\"\/upload/g,'<img src="http://jielixiaoxiong.oss-cn-zhangjiakou.aliyuncs.com/upload');
                        // this.editor.info = tval;
                        console.log(this.$refs['editContent']);
                        // console.log(newtval);
                        this.$refs['editContent'].message = tval;
                    }
                });
            }
        },
        methods:{
            // 提交保存
            submitAdd(name){
                this.$refs[name].validate((valid) => {
                    if (!valid) {
                        this.$Message.error('请检查输入的信息是否正确！');
                        return;
                    }
                    else
                    {
                        if (this.$refs['uploadthumb'].uploadList.length) {
                            this.pages.img_url = this.$refs['uploadthumb'].uploadList[0].url;
                        } else {
                            this.pages.img_url = null;
                        }
                        // console.log(this.$refs['uploadVideo'].videoList)
                        // return;
                        if (this.$refs['uploadVideo'].videoList.length) {
                            this.pages.video = this.$refs['uploadVideo'].videoList[0].url;
                        } else {
                            this.pages.video = null;
                        }
                        // 富文本
                        // this.pages.text = this.editor.info.replace(/\<img src\=\"http\:\/\/jielixiaoxiong.oss-cn-zhangjiakou.aliyuncs.com\/upload/g,'<img src="/upload');
                        // this.pages.text = this.editor.info;
                        // console.log(this.pages);
                        this.pages.text = this.$refs['editContent'].message;
                        if(this.id==0 ){
                            this.$api.pages.create(this.pages).then(res=>{
                                if(res.code == 200)
                                {
                                    this.$Message.success(res.msg);
                                    this.$router.push('/pages/list');
                                }
                            });
                            return;
                        }else{
                            this.pages.id = this.id;
                            this.$api.pages.edit(this.pages).then(res=>{
                                if(res.code == 200)
                                {
                                    this.$Message.success(res.msg);
                                    this.$router.push('/pages/list');
                                }
                            });
                        }
                    }
                })
            },
            // 富文本更新时取值
            change (val) {
                this.editor.info = val
            },
        },
    }
</script>

<style scoped>

</style>
